export function createHttpClient({ axios, baseURL, getToken }) {
  const http = axios.create({
    baseURL,
    withCredentials: true,
  });

  http.interceptors.request.use((config) => {
    const token = getToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  });

  return http;
}

